module.exports = __webpack_public_path__ + "media/images/sp/items/gift/kiribako_01_thumb-ea5bde2c90d198b850440cc46a8d1b81.jpg";